import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ModuleModal = ({ modalIsOpen, setModalIsOpen, addNewComponent, id }) => {
  const [items, setItems] = useState([
    {
      type: "banner",
      src: require("../Shopidy/images/FullWidthBanner.png"),
      alt: "Full Width Banner",
      label: "Full Width Banner",
    },
    {
      type: "slider",
      src: require("../Shopidy/images/image1.png"),
      alt: "Slider Image 1",
      label: "Banner Slider",
    },
    {
      type: "slider",
      src: require("../Shopidy/images/image 2.png"),
      alt: "Slider Image 2",
      label: "Banner Slider",
    },
    {
      type: "category",
      src: require("../Shopidy/images/vegetables & fruits.png"),
      alt: "Categrie Image 1",
      label: "Categorie",
    },
    {
      type: "category",
      src: require("../Shopidy/images/Ata rice & dal.png"),
      alt: "Categrie Image 2",
      label: "Categorie",
    },
    {
      type: "products",
      src: require("../Shopidy/images/vegetables & fruits.png"),
      alt: "Categrie Image 1",
      label: "Products",
    },
    {
      type: "products",
      src: require("../Shopidy/images/Ata rice & dal.png"),
      alt: "Categrie Image 2",
      label: "Products",
    },
    // {
    //   type: "vertical_banners",
    //   src: require("../Shopidy/images/vegetables & fruits.png"),
    //   alt: "Vertical Image 1",
    //   label: "Vertical Banners",
    // },
    // {
    //   type: "vertical_banners",
    //   src: require("../Shopidy/images/Ata rice & dal.png"),
    //   alt: "Vertical Image 2",
    //   label: "Vertical Banners",
    // },
    {
      type: "middle_banners",
      src: require("../Shopidy/images/FullWidthBanner.png"),
      alt: "Middle Banners",
      label: "Middle Banners",
    },
    {
      type: "featured_this_week",
      src: require("../Shopidy/images/FullWidthBanner.png"),
      alt: "Featured This Week",
      label: "Featured This Week",
    },
    // {
    //   type: "onebytwo_banners",
    //   src: require("../Shopidy/images/FullWidthBanner.png"),
    //   alt: "Middle Banners",
    //   label: "One By Two Banners",
    // },
    // {
    //   type: "onebytwo_banners",
    //   src: require("../Shopidy/images/FullWidthBanner.png"),
    //   alt: "Middle Banners",
    //   label: "One By Two Banners",
    // },
    {
      type: "promotional_banner",
      src: require("../Shopidy/images/FullWidthBanner.png"),
      alt: "Promotional Banners",
      label: "Promotional Section",
    },
    {
      type: "category_grouping",
      src: require("../Shopidy/images/vegetables & fruits.png"),
      alt: "Category Grouping Image 1",
      label: "Category Grouping",
    },
    {
      type: "category_grouping",
      src: require("../Shopidy/images/Ata rice & dal.png"),
      alt: "Category Grouping Image 2",
      label: "Category Grouping",
    },
  ]);
  const handleModuleType = (type) => {
    addNewComponent(id, type);
    setShowModal(false);
    setModalIsOpen(false);
  };
  const renderItems = () => {
    const groupedItems = {};

    // Group items by type
    items.forEach((data) => {
      if (!groupedItems[data.type]) {
        groupedItems[data.type] = {
          items: [],
          label: data.label,
        };
      }
      groupedItems[data.type].items.push(data);
    });

    const renderedItems = Object.entries(groupedItems).map(
      ([type, { items, label }], index) => (
        <div key={index} className="col-6 cursor-pointer">
          <div className="module-border">
            {type === "image" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type !== "image" &&
              type !== "slider" &&
              type !== "category" &&
              type !== "products" &&
              type !== "vertical_banners" &&
              type !== "category_grouping" &&
              type !== "featured_this_week" && (
                <div onClick={() => handleModuleType(label)}>
                  {items.map((item, itemIndex) => (
                    <img
                      key={itemIndex}
                      src={item.src}
                      alt={item.alt}
                      style={{
                        width:
                          type === "quill" || type === "banner"
                            ? "100%"
                            : "160px",
                        height: type === "quill" ? "161px" : "auto",
                        border: type === "quill" ? "1px solid #000" : "none", // Apply border only to 'quill'
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              )}
            {type === "slider" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type === "category" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type === "products" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type === "vertical_banners" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type === "category_grouping" && (
              <div className="row" onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="col-6 p-2">
                    <img
                      src={item.src}
                      alt={item.alt}
                      style={{ width: "100%", height: "88px" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {type === "featured_this_week" && (
              <div onClick={() => handleModuleType(label)}>
                {items.map((item, itemIndex) => (
                  <img
                    key={itemIndex}
                    src={item.src}
                    alt={item.alt}
                    style={{ width: "100%", height: "auto" }}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="text-center mt-2">
            <strong style={{ color: "#5C5C5C" }}>{label}</strong>
          </div>
        </div>
      )
    );

    return renderedItems;
  };

  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setModalIsOpen(false);
  };
  useEffect(() => {
    if (modalIsOpen) {
      openModal();
    } else {
      closeModal();
    }
  }, [modalIsOpen]);
  return (
    <div>
      <Modal centered size="lg" show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Module</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row align-items-center">{renderItems()}</div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModuleModal;
